import React, { Component } from "react";

import GoogleAnalytics from "react-ga";

const withTracker = (WrappedComponent, options = {}) => {
	const trackPage = page => {
		const analyticsEnabled = localStorage.getItem("enableGoogleAnalytics") === "true";
		const analyticsId = localStorage.getItem("googleAnalyticsId");
		const isLocalDevHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

		// Guard: skip GA in local development and when tracking config is incomplete.
		if (!analyticsEnabled || !analyticsId || isLocalDevHost) {
			return;
		}

		try {
			GoogleAnalytics.initialize(analyticsId);
			GoogleAnalytics.set({
				page,
				...options
			});
			GoogleAnalytics.pageview(page);
		} catch (error) {
			console.warn("[Tracker] GA init failed, continuing without crash", error);
		}
	};

	const HOC = class extends Component {
		componentDidMount() {
			const page = this.props.location.pathname;
			trackPage(page);
		}

		componentWillReceiveProps(nextProps) {
			const currentPage = this.props.location.pathname;
			const nextPage = nextProps.location.pathname;

			if (currentPage !== nextPage) {
				trackPage(nextPage);
			}
		}

		render() {
			return <WrappedComponent {...this.props} />;
		}
	};

	return HOC;
};

export default withTracker;
